/** Stable localStorage scope ids for list filter persistence. */

export function applicantsJobScope(jobId) {
  return jobId ? `applicants:job:${jobId}` : null;
}

export function rolesCompanyScope(companyId) {
  return companyId ? `roles:company:${companyId}` : null;
}

export function applicantSearchCompanyScope(companyId) {
  return companyId ? `applicant-search:company:${companyId}` : null;
}
